//region block: pre-declaration
//endregion
function _B0___init__impl__6otxhp(b0) {
  return b0;
}
function _B0___get_b0__impl__g161pk($this) {
  return $this;
}
//region block: exports
export {
  _B0___init__impl__6otxhp as _B0___init__impl__6otxhp3mcruxpyvxyvt,
  _B0___get_b0__impl__g161pk as _B0___get_b0__impl__g161pk3gu6min7plxp0,
};
//endregion

//# sourceMappingURL=-EndianUtils.mjs.map
